import { inject, Injectable } from '@angular/core';
import {
  AbstractEntityApiService,
  ConfBaseEntityApiService,
} from '@corezilla/api';
import { User } from '@corezilla/api/features/auth/interfaces/user';

@Injectable({ providedIn: 'root' })
export class UsersApi extends AbstractEntityApiService<User> {
  /** Reuse the configuration-scoped base entity API for CRUD plumbing. */
  protected override readonly api = inject(ConfBaseEntityApiService<User>);

  /** Entity collection path handled by the backend. */
  override endpoint = 'users';
}
